import Claim from "models/claim";
export default {
  data() {
    return {
      // 处理方案列表
      dealMethodList: [
        { id: 1, name: '补发' },
        { id: 2, name: '退差价' },
        { id: 3, name: '退款' },
      ],
      // 责任归属分类列表
      responsiblePartyList: [
        { id: 1, name: '仓库' },
        { id: 2, name: '物流' }
      ],
      // 问题分类列表
      logisticsProblemTypeList: []
    }
  },
  created() {
  },
  methods: {
    /** 
     * @desc 获取问题分类
    */
    initProblemTypeList() {
      let responsibleType = this.ruleForm.responsibleParty
      Claim.postProblemTypeList(responsibleType).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.text
            arr.push(obj)
          })
          this.logisticsProblemTypeList = arr;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
  }
}